/**
 * Payment action availability — disabled unless REACT_APP_PAYMENTS_ENABLED=true at build time.
 */

export const PAYMENTS_ENABLED = process.env.REACT_APP_PAYMENTS_ENABLED === 'true';

export const PAYMENTS_UNAVAILABLE_TEST_ID = 'payments-unavailable-notice';

export function arePaymentsEnabled() {
  return PAYMENTS_ENABLED;
}
